import dayjs from "dayjs";
import { FC, forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import type { ReactDatePickerProps } from "react-datepicker";
import "./MonthDatePicker.scss";
import ChevronLeftIcon from "../../assets/icons/ChevronLeftIcon";
import ChevronRightIcon from "../../assets/icons/ChevronRightIcon";
import { CaretLeft, CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";

const getMonth = (date: Date) => +dayjs(date).format("MM");

// BUG mismatch tipi @types/react-datepicker (dipendenza transitiva su @types/react v19)
// vs @types/react v18 del progetto: `DatePicker` non è più assegnabile a JSX.ElementType.
// Wrapper funzionale tipizzato per bypassare l'incompatibilità di classe senza usare `any`.
const TypedDatePicker = DatePicker as unknown as (
  props: ReactDatePickerProps
) => JSX.Element;

interface IMonthDatepicker {
  date: Date | null;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
}

export const MonthDatepicker: FC<IMonthDatepicker> = ({
  date,
  changeYear,
  changeMonth,
}) => {
  const [currentDate, setCurrentDate] = useState<Date | null>(date);
  const CustomInputDatePicker = forwardRef(({ value, onClick }: any, ref) => (
    <>
      <div
        className="calendar-month-custom-input"
        onClick={onClick}
        ref={ref as any}
      >
        <span className="data-month-label">{value}</span>
        <CaretLeftIcon style={{ transform: "rotate(-90deg)" }} />
      </div>
    </>
  ));

  useEffect(() => {
    setCurrentDate(date);
  }, [date]);

  return (
    <TypedDatePicker
      customInput={<CustomInputDatePicker />}
      selected={currentDate}
      locale={"it"}
      className={"container-calendar-month"}
      onChange={(dateOnChange) => {
        if (!dateOnChange) return;
        changeYear(+dayjs(dateOnChange!).format("YYYY"));
        changeMonth(getMonth(dateOnChange!) - 1);
        setCurrentDate(dateOnChange);
      }}
      renderCustomHeader={({
        decreaseYear,
        date: dateHeader,
        increaseYear,
        prevYearButtonDisabled,
        nextYearButtonDisabled,
      }) => {
        return (
          <div className="d-flex justify-content-between px-2">
            <button onClick={decreaseYear} disabled={prevYearButtonDisabled}>
              <CaretLeft className="icon me-3 icon-ch-left icon-arrow" />
            </button>
            <span className="month-label">
              {dayjs(dateHeader).format("YYYY")}
            </span>
            <button onClick={increaseYear} disabled={nextYearButtonDisabled}>
              <CaretRightIcon className="icon icon-ch-right icon-arrow" />
            </button>
          </div>
        );
      }}
      dateFormat="MMMM yyyy"
      showMonthYearPicker
    />
  );
};
